var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
import { onNextTick, lockedToAnimationFrames } from "@spscommerce/utils";
var Position;
(function(Position2) {
  Position2["TOP_LEFT"] = "top left";
  Position2["TOP_MIDDLE"] = "top middle";
  Position2["TOP_RIGHT"] = "top right";
  Position2["RIGHT_TOP"] = "right top";
  Position2["RIGHT_MIDDLE"] = "right middle";
  Position2["RIGHT_BOTTOM"] = "right bottom";
  Position2["BOTTOM_RIGHT"] = "bottom right";
  Position2["BOTTOM_MIDDLE"] = "bottom middle";
  Position2["BOTTOM_LEFT"] = "bottom left";
  Position2["LEFT_BOTTOM"] = "left bottom";
  Position2["LEFT_MIDDLE"] = "left middle";
  Position2["LEFT_TOP"] = "left top";
})(Position || (Position = {}));
var PositionAnchor;
(function(PositionAnchor2) {
  PositionAnchor2["TOP_LEFT"] = "top left";
  PositionAnchor2["TOP_RIGHT"] = "top right";
  PositionAnchor2["BOTTOM_LEFT"] = "bottom left";
  PositionAnchor2["BOTTOM_RIGHT"] = "bottom right";
})(PositionAnchor || (PositionAnchor = {}));
const DEFAULT_POSITIONING_OPTIONS = {
  anchor: PositionAnchor.TOP_LEFT,
  offsets: [],
  position: Position.TOP_LEFT
};
(function() {
  if (typeof window !== "object") {
    return;
  }
  if ("IntersectionObserver" in window && "IntersectionObserverEntry" in window && "intersectionRatio" in window.IntersectionObserverEntry.prototype) {
    if (!("isIntersecting" in window.IntersectionObserverEntry.prototype)) {
      Object.defineProperty(window.IntersectionObserverEntry.prototype, "isIntersecting", {
        get: function() {
          return this.intersectionRatio > 0;
        }
      });
    }
    return;
  }
  function getFrameElement(doc) {
    try {
      return doc.defaultView && doc.defaultView.frameElement || null;
    } catch (e) {
      return null;
    }
  }
  var document2 = function(startDoc) {
    var doc = startDoc;
    var frame = getFrameElement(doc);
    while (frame) {
      doc = frame.ownerDocument;
      frame = getFrameElement(doc);
    }
    return doc;
  }(window.document);
  var registry = [];
  var crossOriginUpdater = null;
  var crossOriginRect = null;
  function IntersectionObserverEntry2(entry) {
    this.time = entry.time;
    this.target = entry.target;
    this.rootBounds = ensureDOMRect(entry.rootBounds);
    this.boundingClientRect = ensureDOMRect(entry.boundingClientRect);
    this.intersectionRect = ensureDOMRect(entry.intersectionRect || getEmptyRect());
    this.isIntersecting = !!entry.intersectionRect;
    var targetRect = this.boundingClientRect;
    var targetArea = targetRect.width * targetRect.height;
    var intersectionRect = this.intersectionRect;
    var intersectionArea = intersectionRect.width * intersectionRect.height;
    if (targetArea) {
      this.intersectionRatio = Number((intersectionArea / targetArea).toFixed(4));
    } else {
      this.intersectionRatio = this.isIntersecting ? 1 : 0;
    }
  }
  function IntersectionObserver2(callback, opt_options) {
    var options = opt_options || {};
    if (typeof callback != "function") {
      throw new Error("callback must be a function");
    }
    if (options.root && options.root.nodeType != 1 && options.root.nodeType != 9) {
      throw new Error("root must be a Document or Element");
    }
    this._checkForIntersections = throttle(this._checkForIntersections.bind(this), this.THROTTLE_TIMEOUT);
    this._callback = callback;
    this._observationTargets = [];
    this._queuedEntries = [];
    this._rootMarginValues = this._parseRootMargin(options.rootMargin);
    this.thresholds = this._initThresholds(options.threshold);
    this.root = options.root || null;
    this.rootMargin = this._rootMarginValues.map(function(margin) {
      return margin.value + margin.unit;
    }).join(" ");
    this._monitoringDocuments = [];
    this._monitoringUnsubscribes = [];
  }
  IntersectionObserver2.prototype.THROTTLE_TIMEOUT = 100;
  IntersectionObserver2.prototype.POLL_INTERVAL = null;
  IntersectionObserver2.prototype.USE_MUTATION_OBSERVER = true;
  IntersectionObserver2._setupCrossOriginUpdater = function() {
    if (!crossOriginUpdater) {
      crossOriginUpdater = function(boundingClientRect, intersectionRect) {
        if (!boundingClientRect || !intersectionRect) {
          crossOriginRect = getEmptyRect();
        } else {
          crossOriginRect = convertFromParentRect(boundingClientRect, intersectionRect);
        }
        registry.forEach(function(observer) {
          observer._checkForIntersections();
        });
      };
    }
    return crossOriginUpdater;
  };
  IntersectionObserver2._resetCrossOriginUpdater = function() {
    crossOriginUpdater = null;
    crossOriginRect = null;
  };
  IntersectionObserver2.prototype.observe = function(target) {
    var isTargetAlreadyObserved = this._observationTargets.some(function(item) {
      return item.element == target;
    });
    if (isTargetAlreadyObserved) {
      return;
    }
    if (!(target && target.nodeType == 1)) {
      throw new Error("target must be an Element");
    }
    this._registerInstance();
    this._observationTargets.push({ element: target, entry: null });
    this._monitorIntersections(target.ownerDocument);
    this._checkForIntersections();
  };
  IntersectionObserver2.prototype.unobserve = function(target) {
    this._observationTargets = this._observationTargets.filter(function(item) {
      return item.element != target;
    });
    this._unmonitorIntersections(target.ownerDocument);
    if (this._observationTargets.length == 0) {
      this._unregisterInstance();
    }
  };
  IntersectionObserver2.prototype.disconnect = function() {
    this._observationTargets = [];
    this._unmonitorAllIntersections();
    this._unregisterInstance();
  };
  IntersectionObserver2.prototype.takeRecords = function() {
    var records = this._queuedEntries.slice();
    this._queuedEntries = [];
    return records;
  };
  IntersectionObserver2.prototype._initThresholds = function(opt_threshold) {
    var threshold = opt_threshold || [0];
    if (!Array.isArray(threshold))
      threshold = [threshold];
    return threshold.sort().filter(function(t, i, a) {
      if (typeof t != "number" || isNaN(t) || t < 0 || t > 1) {
        throw new Error("threshold must be a number between 0 and 1 inclusively");
      }
      return t !== a[i - 1];
    });
  };
  IntersectionObserver2.prototype._parseRootMargin = function(opt_rootMargin) {
    var marginString = opt_rootMargin || "0px";
    var margins = marginString.split(/\s+/).map(function(margin) {
      var parts = /^(-?\d*\.?\d+)(px|%)$/.exec(margin);
      if (!parts) {
        throw new Error("rootMargin must be specified in pixels or percent");
      }
      return { value: parseFloat(parts[1]), unit: parts[2] };
    });
    margins[1] = margins[1] || margins[0];
    margins[2] = margins[2] || margins[0];
    margins[3] = margins[3] || margins[1];
    return margins;
  };
  IntersectionObserver2.prototype._monitorIntersections = function(doc) {
    var win = doc.defaultView;
    if (!win) {
      return;
    }
    if (this._monitoringDocuments.indexOf(doc) != -1) {
      return;
    }
    var callback = this._checkForIntersections;
    var monitoringInterval = null;
    var domObserver = null;
    if (this.POLL_INTERVAL) {
      monitoringInterval = win.setInterval(callback, this.POLL_INTERVAL);
    } else {
      addEvent(win, "resize", callback, true);
      addEvent(doc, "scroll", callback, true);
      if (this.USE_MUTATION_OBSERVER && "MutationObserver" in win) {
        domObserver = new win.MutationObserver(callback);
        domObserver.observe(doc, {
          attributes: true,
          childList: true,
          characterData: true,
          subtree: true
        });
      }
    }
    this._monitoringDocuments.push(doc);
    this._monitoringUnsubscribes.push(function() {
      var win2 = doc.defaultView;
      if (win2) {
        if (monitoringInterval) {
          win2.clearInterval(monitoringInterval);
        }
        removeEvent(win2, "resize", callback, true);
      }
      removeEvent(doc, "scroll", callback, true);
      if (domObserver) {
        domObserver.disconnect();
      }
    });
    var rootDoc = this.root && (this.root.ownerDocument || this.root) || document2;
    if (doc != rootDoc) {
      var frame = getFrameElement(doc);
      if (frame) {
        this._monitorIntersections(frame.ownerDocument);
      }
    }
  };
  IntersectionObserver2.prototype._unmonitorIntersections = function(doc) {
    var index = this._monitoringDocuments.indexOf(doc);
    if (index == -1) {
      return;
    }
    var rootDoc = this.root && (this.root.ownerDocument || this.root) || document2;
    var hasDependentTargets = this._observationTargets.some(function(item) {
      var itemDoc = item.element.ownerDocument;
      if (itemDoc == doc) {
        return true;
      }
      while (itemDoc && itemDoc != rootDoc) {
        var frame2 = getFrameElement(itemDoc);
        itemDoc = frame2 && frame2.ownerDocument;
        if (itemDoc == doc) {
          return true;
        }
      }
      return false;
    });
    if (hasDependentTargets) {
      return;
    }
    var unsubscribe = this._monitoringUnsubscribes[index];
    this._monitoringDocuments.splice(index, 1);
    this._monitoringUnsubscribes.splice(index, 1);
    unsubscribe();
    if (doc != rootDoc) {
      var frame = getFrameElement(doc);
      if (frame) {
        this._unmonitorIntersections(frame.ownerDocument);
      }
    }
  };
  IntersectionObserver2.prototype._unmonitorAllIntersections = function() {
    var unsubscribes = this._monitoringUnsubscribes.slice(0);
    this._monitoringDocuments.length = 0;
    this._monitoringUnsubscribes.length = 0;
    for (var i = 0; i < unsubscribes.length; i++) {
      unsubscribes[i]();
    }
  };
  IntersectionObserver2.prototype._checkForIntersections = function() {
    if (!this.root && crossOriginUpdater && !crossOriginRect) {
      return;
    }
    var rootIsInDom = this._rootIsInDom();
    var rootRect = rootIsInDom ? this._getRootRect() : getEmptyRect();
    this._observationTargets.forEach(function(item) {
      var target = item.element;
      var targetRect = getBoundingClientRect(target);
      var rootContainsTarget = this._rootContainsTarget(target);
      var oldEntry = item.entry;
      var intersectionRect = rootIsInDom && rootContainsTarget && this._computeTargetAndRootIntersection(target, targetRect, rootRect);
      var rootBounds = null;
      if (!this._rootContainsTarget(target)) {
        rootBounds = getEmptyRect();
      } else if (!crossOriginUpdater || this.root) {
        rootBounds = rootRect;
      }
      var newEntry = item.entry = new IntersectionObserverEntry2({
        time: now(),
        target,
        boundingClientRect: targetRect,
        rootBounds,
        intersectionRect
      });
      if (!oldEntry) {
        this._queuedEntries.push(newEntry);
      } else if (rootIsInDom && rootContainsTarget) {
        if (this._hasCrossedThreshold(oldEntry, newEntry)) {
          this._queuedEntries.push(newEntry);
        }
      } else {
        if (oldEntry && oldEntry.isIntersecting) {
          this._queuedEntries.push(newEntry);
        }
      }
    }, this);
    if (this._queuedEntries.length) {
      this._callback(this.takeRecords(), this);
    }
  };
  IntersectionObserver2.prototype._computeTargetAndRootIntersection = function(target, targetRect, rootRect) {
    if (window.getComputedStyle(target).display == "none")
      return;
    var intersectionRect = targetRect;
    var parent = getParentNode(target);
    var atRoot = false;
    while (!atRoot && parent) {
      var parentRect = null;
      var parentComputedStyle = parent.nodeType == 1 ? window.getComputedStyle(parent) : {};
      if (parentComputedStyle.display == "none")
        return null;
      if (parent == this.root || parent.nodeType == 9) {
        atRoot = true;
        if (parent == this.root || parent == document2) {
          if (crossOriginUpdater && !this.root) {
            if (!crossOriginRect || crossOriginRect.width == 0 && crossOriginRect.height == 0) {
              parent = null;
              parentRect = null;
              intersectionRect = null;
            } else {
              parentRect = crossOriginRect;
            }
          } else {
            parentRect = rootRect;
          }
        } else {
          var frame = getParentNode(parent);
          var frameRect = frame && getBoundingClientRect(frame);
          var frameIntersect = frame && this._computeTargetAndRootIntersection(frame, frameRect, rootRect);
          if (frameRect && frameIntersect) {
            parent = frame;
            parentRect = convertFromParentRect(frameRect, frameIntersect);
          } else {
            parent = null;
            intersectionRect = null;
          }
        }
      } else {
        var doc = parent.ownerDocument;
        if (parent != doc.body && parent != doc.documentElement && parentComputedStyle.overflow != "visible") {
          parentRect = getBoundingClientRect(parent);
        }
      }
      if (parentRect) {
        intersectionRect = computeRectIntersection(parentRect, intersectionRect);
      }
      if (!intersectionRect)
        break;
      parent = parent && getParentNode(parent);
    }
    return intersectionRect;
  };
  IntersectionObserver2.prototype._getRootRect = function() {
    var rootRect;
    if (this.root && !isDoc(this.root)) {
      rootRect = getBoundingClientRect(this.root);
    } else {
      var doc = isDoc(this.root) ? this.root : document2;
      var html = doc.documentElement;
      var body = doc.body;
      rootRect = {
        top: 0,
        left: 0,
        right: html.clientWidth || body.clientWidth,
        width: html.clientWidth || body.clientWidth,
        bottom: html.clientHeight || body.clientHeight,
        height: html.clientHeight || body.clientHeight
      };
    }
    return this._expandRectByRootMargin(rootRect);
  };
  IntersectionObserver2.prototype._expandRectByRootMargin = function(rect) {
    var margins = this._rootMarginValues.map(function(margin, i) {
      return margin.unit == "px" ? margin.value : margin.value * (i % 2 ? rect.width : rect.height) / 100;
    });
    var newRect = {
      top: rect.top - margins[0],
      right: rect.right + margins[1],
      bottom: rect.bottom + margins[2],
      left: rect.left - margins[3]
    };
    newRect.width = newRect.right - newRect.left;
    newRect.height = newRect.bottom - newRect.top;
    return newRect;
  };
  IntersectionObserver2.prototype._hasCrossedThreshold = function(oldEntry, newEntry) {
    var oldRatio = oldEntry && oldEntry.isIntersecting ? oldEntry.intersectionRatio || 0 : -1;
    var newRatio = newEntry.isIntersecting ? newEntry.intersectionRatio || 0 : -1;
    if (oldRatio === newRatio)
      return;
    for (var i = 0; i < this.thresholds.length; i++) {
      var threshold = this.thresholds[i];
      if (threshold == oldRatio || threshold == newRatio || threshold < oldRatio !== threshold < newRatio) {
        return true;
      }
    }
  };
  IntersectionObserver2.prototype._rootIsInDom = function() {
    return !this.root || containsDeep(document2, this.root);
  };
  IntersectionObserver2.prototype._rootContainsTarget = function(target) {
    var rootDoc = this.root && (this.root.ownerDocument || this.root) || document2;
    return containsDeep(rootDoc, target) && (!this.root || rootDoc == target.ownerDocument);
  };
  IntersectionObserver2.prototype._registerInstance = function() {
    if (registry.indexOf(this) < 0) {
      registry.push(this);
    }
  };
  IntersectionObserver2.prototype._unregisterInstance = function() {
    var index = registry.indexOf(this);
    if (index != -1)
      registry.splice(index, 1);
  };
  function now() {
    return window.performance && performance.now && performance.now();
  }
  function throttle(fn, timeout) {
    var timer = null;
    return function() {
      if (!timer) {
        timer = setTimeout(function() {
          fn();
          timer = null;
        }, timeout);
      }
    };
  }
  function addEvent(node, event, fn, opt_useCapture) {
    if (typeof node.addEventListener == "function") {
      node.addEventListener(event, fn, opt_useCapture || false);
    } else if (typeof node.attachEvent == "function") {
      node.attachEvent("on" + event, fn);
    }
  }
  function removeEvent(node, event, fn, opt_useCapture) {
    if (typeof node.removeEventListener == "function") {
      node.removeEventListener(event, fn, opt_useCapture || false);
    } else if (typeof node.detatchEvent == "function") {
      node.detatchEvent("on" + event, fn);
    }
  }
  function computeRectIntersection(rect1, rect2) {
    var top = Math.max(rect1.top, rect2.top);
    var bottom = Math.min(rect1.bottom, rect2.bottom);
    var left = Math.max(rect1.left, rect2.left);
    var right = Math.min(rect1.right, rect2.right);
    var width = right - left;
    var height = bottom - top;
    return width >= 0 && height >= 0 && {
      top,
      bottom,
      left,
      right,
      width,
      height
    } || null;
  }
  function getBoundingClientRect(el) {
    var rect;
    try {
      rect = el.getBoundingClientRect();
    } catch (err) {
    }
    if (!rect)
      return getEmptyRect();
    if (!(rect.width && rect.height)) {
      rect = {
        top: rect.top,
        right: rect.right,
        bottom: rect.bottom,
        left: rect.left,
        width: rect.right - rect.left,
        height: rect.bottom - rect.top
      };
    }
    return rect;
  }
  function getEmptyRect() {
    return {
      top: 0,
      bottom: 0,
      left: 0,
      right: 0,
      width: 0,
      height: 0
    };
  }
  function ensureDOMRect(rect) {
    if (!rect || "x" in rect) {
      return rect;
    }
    return {
      top: rect.top,
      y: rect.top,
      bottom: rect.bottom,
      left: rect.left,
      x: rect.left,
      right: rect.right,
      width: rect.width,
      height: rect.height
    };
  }
  function convertFromParentRect(parentBoundingRect, parentIntersectionRect) {
    var top = parentIntersectionRect.top - parentBoundingRect.top;
    var left = parentIntersectionRect.left - parentBoundingRect.left;
    return {
      top,
      left,
      height: parentIntersectionRect.height,
      width: parentIntersectionRect.width,
      bottom: top + parentIntersectionRect.height,
      right: left + parentIntersectionRect.width
    };
  }
  function containsDeep(parent, child) {
    var node = child;
    while (node) {
      if (node == parent)
        return true;
      node = getParentNode(node);
    }
    return false;
  }
  function getParentNode(node) {
    var parent = node.parentNode;
    if (node.nodeType == 9 && node != document2) {
      return getFrameElement(node);
    }
    if (parent && parent.assignedSlot) {
      parent = parent.assignedSlot.parentNode;
    }
    if (parent && parent.nodeType == 11 && parent.host) {
      return parent.host;
    }
    return parent;
  }
  function isDoc(node) {
    return node && node.nodeType === 9;
  }
  window.IntersectionObserver = IntersectionObserver2;
  window.IntersectionObserverEntry = IntersectionObserverEntry2;
})();
var eventemitter3 = { exports: {} };
(function(module) {
  var has = Object.prototype.hasOwnProperty, prefix = "~";
  function Events() {
  }
  if (Object.create) {
    Events.prototype = Object.create(null);
    if (!new Events().__proto__)
      prefix = false;
  }
  function EE(fn, context, once) {
    this.fn = fn;
    this.context = context;
    this.once = once || false;
  }
  function addListener(emitter, event, fn, context, once) {
    if (typeof fn !== "function") {
      throw new TypeError("The listener must be a function");
    }
    var listener = new EE(fn, context || emitter, once), evt = prefix ? prefix + event : event;
    if (!emitter._events[evt])
      emitter._events[evt] = listener, emitter._eventsCount++;
    else if (!emitter._events[evt].fn)
      emitter._events[evt].push(listener);
    else
      emitter._events[evt] = [emitter._events[evt], listener];
    return emitter;
  }
  function clearEvent(emitter, evt) {
    if (--emitter._eventsCount === 0)
      emitter._events = new Events();
    else
      delete emitter._events[evt];
  }
  function EventEmitter() {
    this._events = new Events();
    this._eventsCount = 0;
  }
  EventEmitter.prototype.eventNames = function eventNames() {
    var names = [], events, name;
    if (this._eventsCount === 0)
      return names;
    for (name in events = this._events) {
      if (has.call(events, name))
        names.push(prefix ? name.slice(1) : name);
    }
    if (Object.getOwnPropertySymbols) {
      return names.concat(Object.getOwnPropertySymbols(events));
    }
    return names;
  };
  EventEmitter.prototype.listeners = function listeners(event) {
    var evt = prefix ? prefix + event : event, handlers = this._events[evt];
    if (!handlers)
      return [];
    if (handlers.fn)
      return [handlers.fn];
    for (var i = 0, l = handlers.length, ee = new Array(l); i < l; i++) {
      ee[i] = handlers[i].fn;
    }
    return ee;
  };
  EventEmitter.prototype.listenerCount = function listenerCount(event) {
    var evt = prefix ? prefix + event : event, listeners = this._events[evt];
    if (!listeners)
      return 0;
    if (listeners.fn)
      return 1;
    return listeners.length;
  };
  EventEmitter.prototype.emit = function emit(event, a1, a2, a3, a4, a5) {
    var evt = prefix ? prefix + event : event;
    if (!this._events[evt])
      return false;
    var listeners = this._events[evt], len = arguments.length, args, i;
    if (listeners.fn) {
      if (listeners.once)
        this.removeListener(event, listeners.fn, void 0, true);
      switch (len) {
        case 1:
          return listeners.fn.call(listeners.context), true;
        case 2:
          return listeners.fn.call(listeners.context, a1), true;
        case 3:
          return listeners.fn.call(listeners.context, a1, a2), true;
        case 4:
          return listeners.fn.call(listeners.context, a1, a2, a3), true;
        case 5:
          return listeners.fn.call(listeners.context, a1, a2, a3, a4), true;
        case 6:
          return listeners.fn.call(listeners.context, a1, a2, a3, a4, a5), true;
      }
      for (i = 1, args = new Array(len - 1); i < len; i++) {
        args[i - 1] = arguments[i];
      }
      listeners.fn.apply(listeners.context, args);
    } else {
      var length = listeners.length, j;
      for (i = 0; i < length; i++) {
        if (listeners[i].once)
          this.removeListener(event, listeners[i].fn, void 0, true);
        switch (len) {
          case 1:
            listeners[i].fn.call(listeners[i].context);
            break;
          case 2:
            listeners[i].fn.call(listeners[i].context, a1);
            break;
          case 3:
            listeners[i].fn.call(listeners[i].context, a1, a2);
            break;
          case 4:
            listeners[i].fn.call(listeners[i].context, a1, a2, a3);
            break;
          default:
            if (!args)
              for (j = 1, args = new Array(len - 1); j < len; j++) {
                args[j - 1] = arguments[j];
              }
            listeners[i].fn.apply(listeners[i].context, args);
        }
      }
    }
    return true;
  };
  EventEmitter.prototype.on = function on(event, fn, context) {
    return addListener(this, event, fn, context, false);
  };
  EventEmitter.prototype.once = function once(event, fn, context) {
    return addListener(this, event, fn, context, true);
  };
  EventEmitter.prototype.removeListener = function removeListener(event, fn, context, once) {
    var evt = prefix ? prefix + event : event;
    if (!this._events[evt])
      return this;
    if (!fn) {
      clearEvent(this, evt);
      return this;
    }
    var listeners = this._events[evt];
    if (listeners.fn) {
      if (listeners.fn === fn && (!once || listeners.once) && (!context || listeners.context === context)) {
        clearEvent(this, evt);
      }
    } else {
      for (var i = 0, events = [], length = listeners.length; i < length; i++) {
        if (listeners[i].fn !== fn || once && !listeners[i].once || context && listeners[i].context !== context) {
          events.push(listeners[i]);
        }
      }
      if (events.length)
        this._events[evt] = events.length === 1 ? events[0] : events;
      else
        clearEvent(this, evt);
    }
    return this;
  };
  EventEmitter.prototype.removeAllListeners = function removeAllListeners(event) {
    var evt;
    if (event) {
      evt = prefix ? prefix + event : event;
      if (this._events[evt])
        clearEvent(this, evt);
    } else {
      this._events = new Events();
      this._eventsCount = 0;
    }
    return this;
  };
  EventEmitter.prototype.off = EventEmitter.prototype.removeListener;
  EventEmitter.prototype.addListener = EventEmitter.prototype.on;
  EventEmitter.prefixed = prefix;
  EventEmitter.EventEmitter = EventEmitter;
  {
    module.exports = EventEmitter;
  }
})(eventemitter3);
var __defProp2 = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp2(target, key, result);
  return result;
};
const NAVBAR_HEIGHT = 60;
const _PositioningService = class {
  static on(eventName, handler) {
    _PositioningService.events.on(eventName, handler);
  }
  static off(eventName, handler) {
    _PositioningService.events.off(eventName, handler);
  }
  static once(eventName, handler) {
    _PositioningService.events.once(eventName, handler);
  }
  static checkCollisions(element, otherElements) {
    const otherElementsList = otherElements || Array.from(_PositioningService.elements.keys());
    const bounds = element.getBoundingClientRect();
    const collisions = [];
    for (const otherElement of otherElementsList) {
      if (otherElement !== element) {
        const otherBounds = otherElement.getBoundingClientRect();
        if (otherBounds.left <= bounds.right && otherBounds.right >= bounds.left && otherBounds.top <= bounds.bottom && otherBounds.bottom >= bounds.top) {
          collisions.push(otherElement);
        }
      }
    }
    if (collisions.length) {
      _PositioningService.onElementIntersection(element, collisions);
    }
  }
  static isPositioned(element) {
    return _PositioningService.elements.has(element);
  }
  static getPositioningOptions(element) {
    if (_PositioningService.elements.has(element)) {
      return _PositioningService.elements.get(element);
    }
    return null;
  }
  static position(element, options = {}) {
    const opts = __spreadValues(__spreadValues({}, DEFAULT_POSITIONING_OPTIONS), options);
    let e = element;
    while (e !== document.body) {
      e = e.parentElement;
      if (e.classList.contains("sps-focused-task")) {
        opts.scrollParent = e;
        if (!_PositioningService.registeredScrollParents.has(e)) {
          _PositioningService.registeredScrollParents.add(e);
          e.addEventListener("scroll", _PositioningService.update);
        }
        break;
      }
    }
    element.style.visibility = "hidden";
    if (_PositioningService.elements.size === 0) {
      window.addEventListener("resize", _PositioningService.update);
      window.addEventListener("scroll", _PositioningService.update);
    }
    if (!opts.relativeTo) {
      throw new Error("You must provide an element for the relativeTo option to position an element.");
    }
    _PositioningService.elements.set(element, opts);
    onNextTick(() => {
      _PositioningService.fixElementPosition(element);
      _PositioningService.viewportObserver.observe(element);
      element.style.visibility = "";
      _PositioningService.checkCollisions(element);
    });
  }
  static release(element) {
    if (_PositioningService.elements.has(element)) {
      _PositioningService.clearStyles(element);
      const options = _PositioningService.elements.get(element);
      if (options.scrollParent) {
        options.scrollParent.removeEventListener("scroll", _PositioningService.update);
        _PositioningService.registeredScrollParents.delete(options.scrollParent);
      }
      _PositioningService.elements.delete(element);
      if (_PositioningService.elements.size === 0) {
        window.removeEventListener("resize", _PositioningService.update);
        window.removeEventListener("scroll", _PositioningService.update);
      }
      _PositioningService.viewportObserver.unobserve(element);
    }
  }
  static releaseAll() {
    for (const element of _PositioningService.elements.keys()) {
      _PositioningService.release(element);
    }
  }
  static refresh(element) {
    if (_PositioningService.elements.has(element)) {
      _PositioningService.clearStyles(element);
      _PositioningService.fixElementPosition(element);
      _PositioningService.checkCollisions(element);
    }
  }
  static refreshAll() {
    for (const element of _PositioningService.elements.keys()) {
      _PositioningService.refresh(element);
    }
  }
  static reposition(element, newOptions) {
    if (_PositioningService.elements.has(element)) {
      const options = _PositioningService.elements.get(element);
      _PositioningService.elements.set(element, Object.assign(options, newOptions));
      _PositioningService.refresh(element);
    }
  }
  static onViewportIntersection(entries) {
    for (const entry of entries) {
      const entryCopy = Object.keys(IntersectionObserverEntry.prototype).reduce((copy, key) => __spreadProps(__spreadValues({}, copy), {
        [key]: entry[key]
      }), {});
      entryCopy.rootBounds = entryCopy.rootBounds || _PositioningService.getRootBounds();
      _PositioningService.events.emit("viewportIntersection", Object.freeze(entryCopy));
    }
  }
  static onElementIntersection(target, intersectingWith) {
    _PositioningService.events.emit("elementIntersection", { target, intersectingWith });
  }
  static getRootBounds() {
    const rootWidth = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
    const rootHeight = Math.max(document.documentElement.clientHeight, window.innerHeight || 0);
    return {
      x: 0,
      y: NAVBAR_HEIGHT,
      left: 0,
      top: NAVBAR_HEIGHT,
      right: rootWidth,
      bottom: rootHeight,
      height: rootHeight - NAVBAR_HEIGHT,
      width: rootWidth
    };
  }
  static clearStyles(element) {
    Object.assign(element.style, {
      position: "",
      width: "",
      top: "",
      left: "",
      right: "",
      bottom: "",
      visibility: "",
      zIndex: ""
    });
  }
  static fixElementPosition(element, options) {
    if (!this.elements.has(element)) {
      return;
    }
    const opts = options || this.elements.get(element);
    const rootBounds = this.getRootBounds();
    const positionedElementBounds = element.getBoundingClientRect();
    const relativeTargetBounds = opts.relativeTo.getBoundingClientRect();
    const { width } = opts.useRelativeTargetWidth ? relativeTargetBounds : positionedElementBounds;
    Object.assign(element.style, {
      minWidth: `${width}px`,
      position: "fixed",
      zIndex: opts.zIndex || ""
    });
    let top;
    let left;
    const positionRelativeToTarget = opts.position.split(" ");
    const offsetA = opts.offsets[0] || 0;
    const offsetB = opts.offsets[1] || 0;
    top = 0;
    left = 0;
    switch (positionRelativeToTarget[0]) {
      case "top":
        top = relativeTargetBounds.top - positionedElementBounds.height - offsetA;
        break;
      case "left":
        left = relativeTargetBounds.left - width - offsetA;
        break;
      case "right":
        left = relativeTargetBounds.right + offsetA;
        break;
      case "bottom":
        top = relativeTargetBounds.bottom + offsetA;
        break;
      default:
        throw new Error(`${opts.position} is not a valid position`);
    }
    switch (positionRelativeToTarget[1]) {
      case "left":
        left = relativeTargetBounds.left - offsetB;
        break;
      case "top":
        top = relativeTargetBounds.top - offsetB;
        break;
      case "middle":
        if (positionRelativeToTarget[0] === "top" || positionRelativeToTarget[0] === "bottom") {
          left = relativeTargetBounds.left + relativeTargetBounds.width / 2 - width / 2 + offsetB;
        } else if (positionRelativeToTarget[0] === "left" || positionRelativeToTarget[0] === "right") {
          top = relativeTargetBounds.top + relativeTargetBounds.height / 2 - positionedElementBounds.height / 2 + offsetB;
        }
        break;
      case "bottom":
        top = relativeTargetBounds.bottom - positionedElementBounds.height + offsetB;
        break;
      case "right":
        left = relativeTargetBounds.right - width + offsetB;
        break;
      default:
        throw new Error(`${opts.position} is not a valid position`);
    }
    const bottom = top + positionedElementBounds.height;
    const right = left + positionedElementBounds.width;
    const topPx = `${Math.round(top)}px`;
    const bottomPx = `${Math.round(rootBounds.bottom - bottom)}px`;
    const leftPx = `${Math.round(left)}px`;
    const rightPx = `${Math.round(rootBounds.right - right)}px`;
    switch (opts.anchor) {
      case PositionAnchor.TOP_LEFT:
        Object.assign(element.style, {
          top: topPx,
          bottom: "auto",
          left: leftPx,
          right: "auto"
        });
        break;
      case PositionAnchor.TOP_RIGHT:
        Object.assign(element.style, {
          top: topPx,
          bottom: "auto",
          left: "auto",
          right: rightPx
        });
        break;
      case PositionAnchor.BOTTOM_LEFT:
        Object.assign(element.style, {
          top: "auto",
          bottom: bottomPx,
          left: leftPx,
          right: "auto"
        });
        break;
      case PositionAnchor.BOTTOM_RIGHT:
        Object.assign(element.style, {
          top: "auto",
          bottom: bottomPx,
          left: "auto",
          right: rightPx
        });
        break;
    }
  }
  static update(event) {
    const elements = _PositioningService.elements.entries();
    const updatedElements = [];
    for (const [element, options] of elements) {
      if (!event || event.target === document || event.target === options.scrollParent || event.target === window) {
        _PositioningService.fixElementPosition(element, options);
        _PositioningService.checkCollisions(element, updatedElements);
        updatedElements.push(element);
      }
    }
  }
  on(eventName, handler) {
    _PositioningService.on(eventName, handler);
  }
  off(eventName, handler) {
    _PositioningService.off(eventName, handler);
  }
  once(eventName, handler) {
    _PositioningService.once(eventName, handler);
  }
  isPositioned(element) {
    return _PositioningService.isPositioned(element);
  }
  getPositioningOptions(element) {
    return _PositioningService.getPositioningOptions(element);
  }
  position(element, options = {}) {
    _PositioningService.position(element, options);
  }
  release(element) {
    _PositioningService.release(element);
  }
  releaseAll() {
    _PositioningService.releaseAll();
  }
  refresh(element) {
    _PositioningService.refresh(element);
  }
  refreshAll() {
    _PositioningService.refreshAll();
  }
  reposition(element, newOptions) {
    _PositioningService.reposition(element, newOptions);
  }
};
let PositioningService = _PositioningService;
PositioningService.elements = new Map();
PositioningService.registeredScrollParents = new Set();
PositioningService.events = new eventemitter3.exports.EventEmitter();
PositioningService.viewportObserver = new IntersectionObserver(_PositioningService.onViewportIntersection, {
  rootMargin: `-${NAVBAR_HEIGHT}px 0px 0px`,
  threshold: 1
});
__decorateClass([
  lockedToAnimationFrames
], PositioningService, "update", 1);
export { DEFAULT_POSITIONING_OPTIONS, Position, PositionAnchor, PositioningService };
